import { Box, Button, TextField } from "@mui/material";
import { useFormik } from "formik";
import React from "react";
import { useAppDispatch } from "../../../State/Store";
import { updateSellerAccount } from "../../../State/seller/sellerSlice";
import { UpdateSellerReq } from "../../../types/sellerType";
import * as Yup from "yup"
interface PersionalDetailProp{
  mobile: string,
  sellerName:string,
  email:string
}
const PersionalDetailsEditFormSchema = Yup.object().shape({
  mobile: Yup.string()
        .required("Mobile is required")
        .matches(/^[0-9]{9,15}$/, "Mobile number is not valid"),
  sellerName: Yup.string().required("Seller Name is required"),
})
export const PersionalDetails = (data:PersionalDetailProp) => {
  const dispatch = useAppDispatch()
  const formik = useFormik({
    enableReinitialize: true,   
    initialValues: {
      mobile: data.mobile||"",
      sellerName: data.sellerName||"",
      email: data.email||"",
    },
    validationSchema:PersionalDetailsEditFormSchema,
    onSubmit:async (values:UpdateSellerReq) => {
      
      await dispatch(updateSellerAccount(values)).unwrap()
    },
  });

  return (
    <form  className="space-y-9">
      <TextField
        fullWidth
        name="sellerName"
        label="Name"
        value={formik.values.sellerName}
        onChange={formik.handleChange}
        error={formik.touched.sellerName && Boolean(formik.errors.sellerName)}
        helperText={formik.touched.sellerName && formik.errors.sellerName}
      />
      <TextField
        disabled
        fullWidth
        name="email"
        label="Email"
        value={formik.values.email}
        onChange={formik.handleChange}
        error={formik.touched.email && Boolean(formik.errors.email)}
        helperText={formik.touched.email && formik.errors.email}
      />
      <TextField
        fullWidth
        name="mobile"
        label="Mobile"
        value={formik.values.mobile}
        onChange={formik.handleChange}
        error={formik.touched.mobile && Boolean(formik.errors.mobile)}
        helperText={formik.touched.mobile && formik.errors.mobile}
      />
      

      <Button type="submit" sx={{py:".7rem"}} fullWidth  onClick={(e) => { e.preventDefault(); formik.handleSubmit() }} variant="contained">
        Submit
      </Button>
    </form>
  );
};
